<template>
  <div class="home">
    <PromoStudents></PromoStudents>
    <PromoBlue></PromoBlue>
    <AboutView></AboutView>
  </div>
</template>

<script>
import PromoStudents from '@/components/PromoStudents.vue';
import PromoBlue from '@/components/PromoBlue.vue';
import AboutView from './AboutView.vue';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    PromoStudents,
    PromoBlue,
    AboutView
  }
}
</script>
